module.exports = __webpack_public_path__ + "fepro/img/identity_fail@2x.d6146e4f.png";